module.exports = __webpack_public_path__ + "img/lotto.2fd406b8.png";